const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');

//B012 (Say Hey)
const B012_VALUES = [
{text:'hey',                    value:'sh_greeting_1'},
{text:'how ya going?',          value:'sh_greeting_2'},
{text:'yoohoo!',                value:'sh_greeting_3'},
];

//B022 (Body Bow)
const B022_VALUES = [
{text:'intro',                  value:'kf_body_bow_intro'},
{text:'outro',                  value:'kf_body_bow_outro'},
];
//B023 (Body Chop Block)
const B023_VALUES = [
{text:'left',   value:'kf_body_chop_block_left'},
{text:'right',  value:'kf_body_chop_block_right'},
];
//B027 (Dance Body)
const B027_VALUES = [
{text:'head up/down',           value:'head_up_down'},
{text:'head swing',             value:'body_side_to_side'},
{text:'sway right',             value:'body_slow_sway_right'},
{text:'sway left',              value:'body_slow_sway_left'},
{text:'robot',                  value:'body_fast_sway'},
{text:'circle',                 value:'body_slow_circle'},
{text:'bounce right',           value:'body_bounce_right'},
{text:'bounce left',            value:'body_bounce_left'},
];

const B010_VALUES = [
  {text:'small',   value:'small'},
  {text:'medium',  value:'medium'},
  {text:'large',   value:'large'}
];

const B033_VALUES = [
  {text:'laugh',            value:'body_laugh'},
  {text:'sigh',             value:'sigh_headshake'},
  {text:'grumpy',           value:'look_down_sides'},
  {text:'yes',              value:'headshake_yes'},
  {text:'no',               value:'headshake_no'},
];

const B034_VALUES = [
  {text:'right middle',         value:'body_idle_look_1'},
  {text:'right up',             value:'body_idle_look_2'},
  {text:'right down',           value:'body_idle_look_3'},
  {text:'left up',              value:'body_idle_look_5'},
  {text:'left down',            value:'body_idle_look_6'},
];

const LOOP_VALUES = ['1','2','3','4','5'];

const BODY_MOVES_BLOCKS = [
  { opcode:'body_greeting', text:'Greeting [TYPE]', args:{TYPE:{menu:'B012_menu', type:'string'}}, anim:{name:'{TYPE}', variant:'default', loops:1} }, //B012
  { opcode:'body_wiggle', text:'body wiggle [TYPE] [LOOPS]', args:{TYPE:{menu:'B010_menu', type:'string'},LOOPS:{menu:'Loop_menu', type:'string'}}, anim:{name:'sh_body_hello_wiggle', variant:'{TYPE}', loops:'{LOOPS}'} }, //B010
  { opcode:'body_bow', text:'kungfu bow body [TYPE]', args:{TYPE:{menu:'B022_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B022
  { opcode:'body_block_block', text:'kungfu block body [TYPE]', args:{TYPE:{menu:'B023_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B023
  { opcode:'body_chop_block', text:'kungfu chop body [TYPE]', args:{TYPE:{menu:'B023_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B023
  { opcode:'dance_body', text:'dance body [TYPE]', args:{TYPE:{menu:'B027_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B027
  { opcode:'kungfu_idle_body', text:'kungfu idle body', args:{}, anim:{name:'kf_body_idle_circle', loops:1} }, //B030
  { opcode:'body_reactions', text:'reaction [TYPE]', args:{TYPE:{menu:'B033_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B027
  { opcode:'body_idle', text:'look [TYPE]', args:{TYPE:{menu:'B034_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B034
];


function argSpec(argKey, spec) {
  if (typeof spec === 'string') return { type: ArgumentType.STRING, menu: spec };
  const t = spec?.type === 'number' ? ArgumentType.NUMBER : ArgumentType.STRING;
  return spec?.menu ? { type: t, menu: spec.menu } : { type: t };
}

function interpolate(tpl, args) {
  return String(tpl).replace(/\{(\w+)\}/g, (_, k) => String(args[k] ?? '').replace(/\s+/g,'_'));
}

function toNumberMaybe(v) {
  const n = Number(v); return Number.isFinite(n) ? n : undefined;
}

const buildBlocks = (rawBlocks) => rawBlocks.map(b => ({
    opcode: b.opcode,
    blockType: BlockType.COMMAND,
    text: b.text,
    arguments: Object.fromEntries(Object.entries(b.args || {}).map(([k, spec]) => ([k, argSpec(k, spec)])))
}));

function getBlockHandler(b) {
    return function(args) { // Use 'function' to bind 'this' correctly
        const op = b.anim.op || 'play_animation';
        if (op === 'play_animation') {
            const name = interpolate(b.anim.name, args);
            const variant = b.anim.variant ? interpolate(b.anim.variant, args) : 'default';
            const loops = typeof b.anim.loops === 'string' ? toNumberMaybe(args[b.anim.loops.replace(/[{}]/g, '')]) ?? 1 : (b.anim.loops ?? 1);
            const payload = `{"animName":"${name}","state":"true","variantKey":"${variant}","loops":${loops}}`;
            return this.sendWaitAck({ OP: op, PAYLOAD: payload, TIMEOUT: -1 });
        } else {
            const payload = `{}`;
            return this.sendWaitAck({ OP: op, PAYLOAD: payload, TIMEOUT: -1 });
        }
    };
}

class Scratch3CodematesBody {
    constructor(runtime) {
        this.runtime = runtime;
        this._pending = new Map();
        this._events = new Map();
        this._awaiters = new Map();
        this._onUnityMessage = this._onUnityMessage.bind(this);
        window.addEventListener('unity-message', this._onUnityMessage);
        this.installHandlers(BODY_MOVES_BLOCKS);
    }

    initWebGL() { this.sendNow({ OP:'unity_init' }); }
    resetWebGL() { this.sendNow({ OP:'unity_cleanUp' }); }
    
    getInfo() {
        return {
            id: 'codematesBody',
            name: '🕺 Patch\'s Body Moves',
            color1: '#4AB26E', // Green
            blocks: buildBlocks(BODY_MOVES_BLOCKS),
            menus: {
                B010_menu: { acceptReporters: false, items: B010_VALUES },
                B012_menu: { acceptReporters: false, items: B012_VALUES },
                B022_menu: { acceptReporters: false, items: B022_VALUES },
                B023_menu: { acceptReporters: false, items: B023_VALUES },
                B027_menu: { acceptReporters: false, items: B027_VALUES },
                B033_menu: { acceptReporters: false, items: B033_VALUES },
                B034_menu: { acceptReporters: false, items: B034_VALUES },
                Loop_menu: { acceptReporters: false, items: LOOP_VALUES },
            }
        };
    }
    
    installHandlers(blocks) {
        for (const b of blocks) { this[b.opcode] = getBlockHandler(b).bind(this); }
    }

    // RPC Logic
    sendNow(args) {
        window.__codemates_seq = window.__codemates_seq || 0;
        const op = Cast.toString(args.OP);
        const payload = this._parse(Cast.toString(args.PAYLOAD || '{}'));
        this._post({ seq: ++this._seq, op, data: payload });
    }

    sendWaitAck(args) {
        const op = Cast.toString(args.OP);
        const payload = this._parse(Cast.toString(args.PAYLOAD));
        const n = Number(args.TIMEOUT);
        const timeout = Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
        return this._rpc(op, payload, { waitFor: 'ack', timeout });
    }

    _rpc(op, payload = {}, { timeout = 2000, waitFor } = {}) {
        window.__codemates_seq = window.__codemates_seq || 0;
        const seq = ++window.__codemates_seq;
        const body = { seq, op, data: payload };
        const p = new Promise((resolve, reject) => {
            let t = null;
            if (timeout) {
                t = setTimeout(() => { this._pending.delete(seq); resolve({ seq, op, timeout: true }); }, timeout);
            }
            this._pending.set(seq, { resolve, reject, t, waitFor });
        });
        this._post(body);
        return p;
    }

    _post(body) {
        if (typeof window.sendToUnity === 'function') { try { window.sendToUnity(body); } catch {} }
        else { (window.__unityQueue = window.__unityQueue || []).push(body); }
    }

    _parse(s) {
        try { const o = JSON.parse(s); return typeof o === 'object' && o !== null ? o : { value: s }; }
        catch { return { value: s }; }
    }

    _queueEvent(name, data) {
        const q = this._events.get(name) || [];
        q.push(data);
        this._events.set(name, q);
        const aw = this._awaiters.get(name);
        if (aw && aw.length) aw.shift()();
        this.runtime.startHats('codemates_whenUnityEvent', { EVENT: name });
    }

    _popEvent(name) {
        const q = this._events.get(name) || [];
        if (!q.length) return false;
        q.shift();
        return true;
    }

    _waitForEvent(name) {
        if (this._popEvent(name)) return Promise.resolve();
        return new Promise(r => {
            const list = this._awaiters.get(name) || [];
            list.push(r);
            this._awaiters.set(name, list);
        });
    }

    _onUnityMessage(evt) {
        const msg = evt && (evt.detail || evt.data);
        if (!msg || typeof msg !== 'object') return;
        if (msg.type === 'event' && msg.name) { this._queueEvent(msg.name, msg); return; }
        if (msg.seq && this._pending.has(msg.seq)) {
            const entry = this._pending.get(msg.seq);
            if (entry.t) clearTimeout(entry.t);
            if (!entry.waitFor || entry.waitFor === msg.type || msg.type === 'error') {
                this._pending.delete(msg.seq);
                if (msg.type === 'error') entry.reject(new Error(msg.error || 'unity error'));
                else entry.resolve(msg);
            }
        }
    }
}


module.exports = Scratch3CodematesBody;
